var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDisVolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/shopping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M10.2771 14.8063H12.2236V19.3419C12.2236 20.4003 12.7968 20.6144 13.4961 19.8207L18.2648 14.4032C18.8506 13.7417 18.6049 13.1937 17.7167 13.1937H15.7702V8.65808C15.7702 7.59977 15.1969 7.38559 14.4977 8.17932L9.72902 13.5968C9.14947 14.2646 9.39515 14.8063 10.2771 14.8063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 971",
    opacity: 0.6,
    cx: 14.0003,
    cy: 14,
    r: 11.0833,
    stroke: "white",
    strokeWidth: 1.2,
    strokeDasharray: "2.5 3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisVolt);
export default __webpack_public_path__ + "static/media/icon_dis_volt.3c235583835a1df98e323d4843c3f2d7.svg";
export { ForwardRef as ReactComponent };